"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const largeAgencyCodes_1 = __importDefault(require("./largeAgencyCodes"));
const affinityGroups = {
    A360: {
        hash: 'fdsa360ee',
        homeSecurity: true,
        name: 'Alert 360',
        states: {
            AZ: 2,
            OH: 2,
            IL: 2,
            IN: 2,
            MD: 2,
            MO: 2,
            PA: 2,
            TX: 2
        }
    },
    A360E: {
        hash: 'fda360eeeeemp',
        homeSecurity: true,
        name: 'Alert 360',
        states: {
            AZ: 2,
            OH: 2,
            IL: 2,
            IN: 2,
            MD: 2,
            MO: 2,
            TX: 2
        }
    },
    AAA1: {
        hash: 'f98j1kljzc',
        name: 'American Automobile Association',
        agency: true,
        serviceAgreement: true,
        disableChat: true,
        informationId: 'AAA1'
    },
    AB0001: {
        hash: 'AB0001hash',
        name: 'Above All Insurance',
        agency: true,
        disableChat: true,
        informationId: 'AB0001'
    },
    AB1: {
        hash: 'fdsvu4e',
        homeSecurity: true,
        canBeRemoved: true,
        name: 'Abode Pro Plan',
        additional: 100,
        states: {
            AL: 2,
            AZ: 2,
            CO: 2,
            GA: 2,
            ID: 2,
            IL: 2,
            IN: 2,
            KS: 2,
            KY: 2,
            MD: 2,
            MI: 2,
            MO: 2,
            NE: 2,
            NJ: 2,
            NM: 2,
            NV: 2,
            NY: 2,
            OH: 2,
            OR: 2,
            OK: 2,
            PA: 2,
            RI: 2,
            SC: 2,
            TX: 2,
            UT: 2,
            VA: 2,
            WV: 2,
            WI: 2
        }
    },
    /** For existing Abode Pro Plan customers who shouldn't be charged for it */
    AB2: {
        hash: '4jhif9818v',
        homeSecurity: true,
        name: 'Abode Pro Plan (Existing Customers)',
        states: {
            AL: 2,
            AZ: 2,
            CO: 2,
            GA: 2,
            ID: 2,
            IL: 2,
            IN: 2,
            KS: 2,
            KY: 2,
            MD: 2,
            MI: 2,
            MO: 2,
            NE: 2,
            NJ: 2,
            NM: 2,
            NV: 2,
            NY: 2,
            OH: 2,
            OR: 2,
            OK: 2,
            PA: 2,
            RI: 2,
            SC: 2,
            TX: 2,
            VA: 2,
            WV: 2,
            WI: 2
        }
    },
    ABC1: {
        hash: 'fdsvabcu4e',
        name: 'Action Behavior Centers',
        states: {
            AZ: 2,
            CO: 2,
            IL: 2,
            IN: 2,
            MI: 2,
            MO: 2,
            NE: 2,
            OH: 2,
            OK: 2,
            PA: 2,
            TX: 2
        }
    },
    AC1: {
        hash: 'fdscccce',
        name: 'Acorns',
        states: {
            AZ: 0,
            OH: 0,
            IL: 0,
            IN: 0,
            MO: 0,
            TX: 0
        }
    },
    AC0001: {
        hash: 'AC0001has',
        name: 'Angell & Co LLC',
        agency: true,
        disableChat: true,
        informationId: 'AC0001'
    },
    AD0001: {
        hash: 'AD0001has',
        name: 'Advantage Insurance Agency',
        agency: true,
        disableChat: true,
        informationId: 'AD0001'
    },
    AD1: {
        hash: 'addhv8',
        featuredProvider: true,
        homeSecurity: true,
        name: 'ADT',
        signUpThroughBranch: true,
        states: {
            AL: 2,
            AZ: 2,
            CO: 2,
            GA: 2,
            IA: 2,
            ID: 2,
            IL: 2,
            IN: 2,
            KS: 2,
            KY: 2,
            MD: 2,
            MI: 2,
            MO: 2,
            NE: 2,
            NJ: 2,
            NM: 2,
            NV: 2,
            NY: 2,
            OH: 2,
            OR: 2,
            OK: 2,
            RI: 2,
            SC: 2,
            SD: 2,
            TX: 2,
            UT: 2,
            VA: 2,
            WI: 2,
            WV: 2
        }
    },
    ADE: {
        hash: 'addhv8E',
        featuredProvider: true,
        homeSecurity: true,
        name: 'ADT Employee',
        states: {
            AL: 2,
            AZ: 2,
            CO: 2,
            GA: 2,
            IA: 2,
            ID: 2,
            IL: 2,
            IN: 2,
            KS: 2,
            KY: 2,
            MD: 2,
            MI: 2,
            MO: 2,
            NE: 2,
            NJ: 2,
            NM: 2,
            NV: 2,
            NY: 2,
            OH: 2,
            OR: 2,
            OK: 2,
            RI: 2,
            SC: 2,
            SD: 2,
            TX: 2,
            UT: 2,
            VA: 2,
            WI: 2,
            WV: 2
        }
    },
    AGD0001: {
        hash: 'AGD0001has',
        name: 'A. G. D. Insurance, LLC',
        agency: true,
        disableChat: true,
        informationId: 'AGD0001'
    },
    AGHRO: {
        hash: 'baager',
        name: 'Agent Hero',
        agency: true,
        serviceAgreement: true,
        disableChat: true
    },
    aghro107: {
        hash: 'aghro107hash',
        name: 'Insuragy, LLC'
    },
    AGHRO48P: {
        hash: 'AGHRO48Phash',
        name: 'Hometown Insurance Services, Inc.',
        agency: true,
        disableChat: true,
        informationId: 'AGHRO48P'
    },
    AGM1: {
        name: 'Affinity Group Mortgage',
        hash: '7dhdf8vc'
    },
    AHG0001P: {
        hash: 'AHG0001Phash',
        name: 'Auto Home Group',
        agency: true,
        disableChat: true,
        informationId: 'AHG0001P'
    },
    AGHRO111P: {
        hash: 'AGHRO111Phash',
        name: 'Scheer Insurance Services',
        agency: true,
        disableChat: true,
        informationId: 'AGHRO111P'
    },
    AGRO226: {
        hash: 'AGRO226hash',
        name: 'Concrete Insurance',
        disableChat: true,
        informationId: 'AGRO226'
    },
    AGRO247: {
        hash: 'AGRO247hash',
        name: 'Sergios Insurance Agency',
        disableChat: true,
        informationId: 'AGRO247'
    },
    AIA0001_10P: {
        hash: 'AIA0001_10Phash',
        name: 'Alabama Insurance Agency',
        agency: true,
        disableChat: true,
        informationId: 'AIA0001_10P'
    },
    AIM0001: {
        hash: 'AIM0001has',
        name: 'Alabama Insurance Markets',
        agency: true,
        disableChat: true,
        informationId: 'AIM0001'
    },
    AIS: {
        hash: 'AIShash',
        name: 'American Insurance Strategies'
    },
    AIS1: {
        hash: 'AIS1hash',
        agency: true,
        serviceAgreement: true,
        name: 'American Insurance Strategies'
    },
    AL0001_1: {
        hash: 'AL0001_1hash',
        agency: true,
        name: 'Alpha One Insurance Agency',
        informationId: 'AL0001_1'
    },
    ALP0001: {
        hash: 'ALP0001hash',
        agency: true,
        name: 'Alpine Life Planning Strategies',
        informationId: 'ALP0001'
    },
    ALNK1: {
        hash: 'alnk1hash',
        agency: true,
        serviceAgreement: true,
        name: 'ALINK Insurance Service'
    },
    ANSFIN1: {
        name: 'Answer Financial',
        hash: '0jkl298lsdf',
        agency: true,
        serviceAgreement: true,
        disableChat: true
    },
    AM0001_1: {
        hash: 'AM0001_1hash',
        name: 'American Insurance Services',
        agency: true,
        disableChat: true,
        informationId: 'AM0001_1'
    },
    AM0001_2: {
        hash: 'AM0001_1hash',
        name: 'American Insurance Services',
        agency: true,
        disableChat: true,
        informationId: 'AM0001_2'
    },
    AP1: {
        hash: '7dhv8',
        name: 'Alert Protective',
        states: {
            IL: 2
        }
    },
    APE: {
        hash: '7dhv8E',
        name: 'Alert Protective',
        states: {
            IL: 2
        }
    },
    APHW: {
        hash: 'ahfgdspew',
        name: "America's Preferred Home Warranty",
        informationId: 'AHPW',
        states: {
            AZ: 1,
            CO: 1,
            IA: 1,
            ID: 1,
            IL: 1,
            IN: 1,
            KY: 1,
            ME: 1,
            MO: 1,
            ND: 1,
            NE: 1,
            NH: 1,
            OH: 1,
            OK: 1,
            SD: 1,
            TX: 1,
            UT: 1,
            VT: 1,
            WI: 1
        }
    },
    APRG1: {
        name: 'The Savings Group (AutoPay/RateGenius)',
        hash: 'aprg1hash'
    },
    AR0001: {
        hash: 'ar00011hash',
        agency: true,
        name: 'Arizona Insurance Guy',
        informationId: 'AR0001'
    },
    AR0001P: {
        hash: 'AR0001Phash',
        agency: true,
        name: 'Arizona Insurance Guy',
        informationId: 'AR0001P'
    },
    ARCH1: {
        hash: 'arch1hash',
        name: 'Archer Insurance Solutions',
        agency: true,
        informationId: 'ARCH1'
    },
    ASKOTTO: {
        hash: '7ask88otto',
        name: 'AskOtto',
        informationId: 'ASKOTTO'
    },
    ASQ1: {
        hash: 'asq1hash',
        name: 'ASQ Technologies LLC',
        agency: true
    },
    ASQ2: {
        hash: 'asq2hash',
        name: 'Grace Affordable Insurance, Inc.',
        agency: true
    },
    ASQ3: {
        hash: 'asq3hash',
        name: 'Clark-Vivens Insurance Agency dba Renegade Insurance',
        agency: true
    },
    ASQ4: {
        hash: 'asq4hash',
        name: 'ASQ Technologies LLC',
        agency: true
    },
    ASQ5: {
        hash: 'asq5hash',
        name: 'ASQ Technologies LLC',
        agency: true
    },
    ASQ6: {
        hash: 'asq6hash',
        name: 'ASQ Technologies LLC',
        agency: true
    },
    ASQ8: {
        hash: 'asq6hash',
        name: 'ASQ Technologies LLC',
        agency: true,
        informationId: 'ASQ8'
    },
    ASQ9: {
        hash: 'asq6hash',
        name: 'ASQ Technologies LLC',
        agency: true,
        informationId: 'ASQ9'
    },
    AST1: {
        hash: 'ast1hash',
        name: 'Asterion Insurance Services LLC',
        agency: true
    },
    AURE1: {
        hash: 'ytQym4cF4rGAGhy6',
        name: 'Benchmark Insurance Group'
    },
    AZL1: {
        hash: 'dclesdfisg',
        name: 'Arizona Lending Group',
        states: {
            AZ: 2
        }
    },
    BA0001P: {
        hash: 'BA0001Phash',
        name: 'Beasy Insurance Services',
        agency: true,
        disableChat: true,
        informationId: 'BA0001P'
    },
    BA1: {
        hash: 'babetter',
        name: 'Betters Agency',
        agency: true,
        serviceAgreement: true,
        disableChat: true
    },
    BAD: {
        hash: 'baddab',
        name: 'BAD Agency from QTB API',
        agency: true
    },
    BAX1: {
        hash: 'bax1hash',
        name: 'Baxter Insurance Agency',
        agency: true
    },
    BCA: {
        name: 'Bob Caldwell Chrysler Jeep',
        hash: 'bdcz4xvy'
    },
    BDDG1: {
        hash: 'bddg1hash',
        name: 'Bird Dog Insurance Services, LLC',
        agency: true
    },
    BE0002: {
        hash: 'BE0002hash',
        agency: true,
        name: 'Benefield & Tabb Insurance Inc.',
        informationId: 'BE0002'
    },
    BF0001: {
        hash: 'bf0001hash',
        name: 'Boomer Financial Group',
        agency: true
    },
    BH1: {
        name: 'Buckeye Honda',
        hash: 'gf5subh18g'
    },
    BIG1: {
        hash: 'fsdbuds87',
        name: 'Benchmark Insurance Group'
    },
    BLRDG1: {
        hash: 'blrdg1hash',
        name: 'Blue Ridge Insurance',
        agency: true
    },
    BN1: {
        name: 'Buckeye Nissan',
        hash: 'basj6kdvu'
    },
    BOBB: {
        name: 'Bobb Automotive',
        hash: 'lsdy76v5'
    },
    BP0001: {
        hash: 'bp00011hash',
        name: 'BluePrint Risk LLC',
        agency: true
    },
    BRANS1: {
        hash: 'brans1hash',
        name: 'Branscomb and Associates, LLC',
        agency: true
    },
    BRIJ1: {
        hash: 'brij1hash',
        name: 'InsureUs',
        agency: true
    },
    BPRS1: {
        hash: 'bprs1hash',
        name: 'Bespros Insurance and Financial Services LLC',
        agency: true
    },
    BRPT1: {
        hash: 'brpt1hash',
        name: 'Bridgepoint Insurance Solutions',
        agency: true
    },
    BW0001: {
        hash: 'BW0001hash',
        name: 'BainsWest',
        agency: true,
        disableChat: true,
        informationId: 'BW0001'
    },
    BWB: {
        hash: 'babwer',
        name: 'Baker Welman Brown',
        agency: true,
        serviceAgreement: true,
        disableChat: true
    },
    CAF1: {
        name: 'CarsFast',
        hash: '12jlkjvasd3',
        informationId: 'CAF1'
    },
    CAPK: {
        name: 'Capital Kia',
        hash: 'gf5ckiad98g'
    },
    CATN1: {
        hash: 'catn1hash',
        name: 'Catanzaro Insurance',
        agency: true
    },
    CAV: {
        hash: 'nocavf1',
        agency: true,
        serviceAgreement: true,
        name: 'Cavender Insurance',
        informationId: 'CAV'
    },
    CC1: {
        hash: 'cochdcolisd',
        name: 'Coach Collins Insurance',
        agency: true,
        serviceAgreement: true,
        informationId: 'CC1'
    },
    CCM1: {
        hash: '9jlkj109puisd',
        name: 'Cherry Creek Mortgage'
    },
    CCT: {
        name: 'Columbus Car Trader',
        hash: 'gfcard98g'
    },
    CE0001: {
        hash: 'CE0001hash',
        agency: true,
        name: 'Centennial Insurance Group, Inc.',
        informationId: 'CE0001'
    },
    CF0001_1: {
        hash: 'CF0001_1hash',
        name: 'CareFirst Insurance',
        agency: true,
        disableChat: true,
        informationId: 'CF0001_1'
    },
    CF0001_2: {
        hash: 'CF0001_2hash',
        name: 'Carefirst Insurance',
        agency: true,
        disableChat: true,
        informationId: 'CF0001_2'
    },
    CFG1: {
        hash: 'dfcfgad87',
        name: 'Crossfit Grandview'
    },
    CHIME1: {
        hash: 'chdimeow',
        name: 'Chime',
        states: {
            AZ: 2,
            CO: 2,
            IL: 2,
            IN: 2,
            KY: 2,
            MD: 2,
            MI: 2,
            MO: 2,
            NE: 2,
            OH: 2,
            OK: 2,
            TX: 2,
            UT: 2,
            WI: 2
        }
    },
    CI1: {
        hash: 'cidufds9',
        name: 'Cleveland Insurance Brokers',
        agency: true,
        serviceAgreement: true,
        informationId: 'CI1',
        disableChat: true
    },
    CI2: {
        hash: 'cidufds92',
        name: 'Cleveland Insurance Brokers',
        agency: true,
        serviceAgreement: true,
        informationId: 'CI1',
        disableChat: true
    },
    CI3: {
        hash: 'cidufds93',
        name: 'Cleveland Insurance Brokers',
        agency: true,
        serviceAgreement: true,
        informationId: 'CI1',
        disableChat: true
    },
    CI4: {
        hash: 'cidufds94',
        name: 'Cleveland Insurance Brokers',
        agency: true,
        serviceAgreement: true,
        informationId: 'CI1',
        disableChat: true
    },
    CI5: {
        hash: 'cidufds95',
        name: 'Cleveland Insurance Brokers',
        agency: true,
        serviceAgreement: true,
        informationId: 'CI1',
        disableChat: true
    },
    CI5P: {
        hash: 'CI5Phash',
        name: 'Cleveland Insurance Brokers',
        agency: true,
        disableChat: true,
        informationId: 'CI5P'
    },
    CI0001: {
        hash: 'CI0001hash',
        name: 'Christensen Insurance',
        agency: true,
        disableChat: true,
        informationId: 'CI0001'
    },
    CIG0001: {
        hash: 'cig0001hash',
        agency: true,
        name: 'Community Insurance Group',
        informationId: 'CIG0001'
    },
    CINS1: {
        hash: 'cins1hash',
        agency: true,
        name: 'C1 Insurance Group'
    },
    CISS: {
        hash: 'nciss3f1',
        agency: true,
        serviceAgreement: true,
        name: 'Colorado Insurance',
        informationId: 'CISS'
    },
    CKIA: {
        name: 'Celebration Kia',
        hash: 'gf5ckcelg'
    },
    CL0002: {
        hash: 'CL0002hash',
        name: 'Clary Insurance LLC',
        agency: true,
        disableChat: true,
        informationId: 'CL0002'
    },
    CLEND1: {
        hash: 'dclesdfisg',
        name: 'Coastal Lending Group',
        states: {
            MD: 2
        }
    },
    CMRG1: {
        hash: 'cmrg1hash',
        name: 'Camargo Insurance',
        agency: true
    },
    CO0001: {
        hash: 'CO0001hash',
        name: 'Cornerstone Insurance Agency, LLC',
        agency: true,
        informationId: 'CO0001',
        disableChat: true
    },
    COVSAGE: {
        hash: 'cusage294tree',
        agency: true
    },
    CT1: {
        hash: 'cudngeu294tree',
        agency: true
    },
    COM1: {
        hash: '2xjv2m5u',
        name: 'Compare.com'
    },
    COV1: {
        hash: 'dfsjkwww3sfa7',
        name: 'Cover.com',
        agency: true
    },
    CPN: {
        name: 'Cedar Park Nissan',
        hash: 'gfcpncvtg'
    },
    CRLS1: {
        hash: 'crls1hash',
        name: 'CHARALES INSURANCE AGY INC',
        agency: true
    },
    CV0001: {
        hash: 'cv0001hash',
        name: 'Clear View Insurance Services LLC',
        agency: true
    },
    CROL1: {
        hash: 'crol1hash',
        name: 'Carroll Agency Inc',
        agency: true
    },
    CROL1P: {
        hash: 'crol1phash',
        name: 'Carroll Agency Inc',
        agency: true
    },
    CVT1: {
        name: 'Covert CJDR',
        hash: 'gf5sucvtg'
    },
    CY0001_P: {
        hash: 'cy0001_Phash',
        name: 'Coyle Insurance Agency',
        agency: true,
        disableChat: true,
        informationId: 'CY0001_P'
    },
    DAA: {
        name: 'Don Ayres Acura',
        hash: 'sfd4145et'
    },
    DAH: {
        name: 'Don Ayres Honda',
        hash: '5sdf14gr'
    },
    DGC: {
        name: 'Dave Gill Chevrolet',
        hash: 'gfdgcd98g'
    },
    DG1: {
        hash: 'iewdgs532',
        agency: true,
        serviceAgreement: true,
        name: 'DG Agency',
        informationId: 'DG1',
        disableChat: true
    },
    DH1: {
        name: 'Dennis Hyundai East',
        hash: '87asd5fgh'
    },
    DI0001_1: {
        hash: 'DI0001_1hash',
        name: 'Danker Insurance',
        agency: true,
        disableChat: true,
        informationId: 'DI0001_1'
    },
    DI0001_2: {
        hash: 'DI0001_2hash',
        name: 'Danker Insurance',
        agency: true,
        disableChat: true,
        informationId: 'DI0001_2'
    },
    DMF: {
        name: 'Dick Masheter Ford',
        hash: 'gfddmf98g'
    },
    DP1: {
        hash: 'dfsdp1sfa7',
        name: 'Dealer Policy',
        agency: true
    },
    DT1: {
        hash: '2a48d',
        name: 'Driver Technologies',
        states: {
            AL: 2,
            AZ: 2,
            CO: 2,
            GA: 2,
            IL: 2,
            IN: 2,
            KS: 2,
            KY: 2,
            MD: 2,
            MI: 2,
            MO: 2,
            NE: 2,
            NJ: 2,
            NV: 2,
            NY: 2,
            OH: 2,
            OR: 2,
            OK: 2,
            RI: 2,
            SC: 2,
            TX: 2,
            UT: 2,
            VA: 2,
            WI: 2,
            WV: 2
        }
    },
    DTE: {
        hash: '2a48dE',
        name: 'Driver Technologies',
        states: {
            AL: 2,
            AZ: 2,
            CO: 2,
            GA: 2,
            IL: 2,
            IN: 2,
            KS: 2,
            KY: 2,
            MD: 2,
            MI: 2,
            MO: 2,
            NE: 2,
            NJ: 2,
            NV: 2,
            NY: 2,
            OH: 2,
            OR: 2,
            OK: 2,
            RI: 2,
            SC: 2,
            TX: 2,
            VA: 2,
            WI: 2,
            WV: 2
        }
    },
    DTM: {
        name: 'Drive Time',
        hash: '65fds16df4g'
    },
    DWJ: {
        name: 'Driving with Janae',
        hash: 'df4d562as'
    },
    EF0001: {
        hash: 'ef00011hash',
        name: 'Ed Fowls Insurance',
        agency: true
    },
    EI0001: {
        hash: 'ei00011hash',
        name: 'EIA',
        agency: true
    },
    EI1: {
        hash: 'eid7vn238fdas',
        name: 'Eades Insurance',
        agency: true,
        serviceAgreement: true,
        informationId: 'EI1',
        disableChat: true
    },
    EI2: {
        hash: 'eid7vn238fdas2',
        name: 'Eades Insurance',
        agency: true,
        serviceAgreement: true,
        informationId: 'EI1',
        disableChat: true
    },
    EIC0001: {
        hash: 'EIC0001hash',
        name: 'Elite Insuranec Company Inc.',
        agency: true,
        disableChat: true,
        informationId: 'EIC0001'
    },
    EIG0001: {
        hash: 'eig0001hash',
        name: 'Eddys Independent Group, LLC',
        agency: true,
        informationId: 'EIG0001'
    },
    EIG0001_1: {
        hash: 'eig0001_1hash',
        name: 'Eddys Independent Group, LLC',
        informationId: 'EIG0001_1'
    },
    ELD1: {
        hash: 'dfkjvfusadeld',
        name: 'Elder Insurance',
        informationId: 'ELD1'
    },
    EM1: {
        hash: '4389dfsnj8d'
    },
    EN0001: {
        hash: 'EN0001hash',
        name: 'Endgame Insurance',
        agency: true,
        informationId: 'EN0001',
        disableChat: true
    },
    EPLR1: {
        hash: 'eplr1hash',
        agency: true,
        name: 'Eppler Insurance Group, LLC'
    },
    ERFY1: {
        hash: 'erfy1hash',
        name: 'Eversify Insurance',
        agency: true
    },
    EXM: {
        name: 'Exclusive Motorcars',
        hash: '8kjf75l798'
    },
    FA0001: {
        hash: 'FA0001hash',
        name: 'Falkner Insurance',
        agency: true,
        informationId: 'FA0001',
        disableChat: true
    },
    FA0002: {
        hash: 'FA0002hash',
        name: 'Falk Agency, LLC',
        agency: true,
        disableChat: true,
        informationId: 'FA0002'
    },
    FAHW: {
        hash: 'ahfgdspew',
        name: 'First American Home Warranty',
        states: {
            AZ: 1,
            CO: 1,
            IL: 1,
            IN: 1,
            MD: 1,
            ME: 1,
            MO: 1,
            ND: 1,
            NE: 1,
            NH: 1,
            OH: 1,
            OK: 1,
            SD: 1,
            TX: 1,
            UT: 1,
            VT: 1,
            WI: 1
        }
    },
    FF0001_1P: {
        hash: 'ff0001_phash',
        name: 'Family First Insurance Alliance, LLC',
        agency: true,
        informationId: 'FF0001_1P'
    },
    FOF0001_4P: {
        hash: 'FOF0001_4Phash',
        name: '405 Insurance Advisors',
        agency: true,
        disableChat: true,
        informationId: 'FOF0001_4P'
    },
    FOF0001_5P: {
        hash: 'FOF0001_5Phash',
        name: '405 Insurance Advisors',
        agency: true,
        disableChat: true,
        informationId: 'FOF0001_5P'
    },
    FOF0001_1P: {
        hash: 'FOF0001_1Phash',
        name: '405 Insurance Advisors',
        agency: true,
        disableChat: true,
        informationId: 'FOF0001_1P'
    },
    FH1: {
        hash: 'h2O0W',
        name: 'Fischer Homes',
        states: {
            KY: 2,
            MD: 1,
            OH: 1,
            OK: 1
        }
    },
    FHE: {
        hash: 'h2O0WE',
        name: 'Fischer Homes',
        states: {
            KY: 2,
            IN: 1,
            OH: 1,
            OK: 1
        }
    },
    FLO1: {
        hash: 'BXrw5z',
        name: 'Floify'
    },
    FLO2: {
        hash: 'BXrw5z2',
        name: 'Floify',
        states: {
            CO: 2,
            IA: 2,
            IL: 2,
            TX: 2
        }
    },
    FLOE: {
        hash: 'BXrw5z3',
        name: 'Floify Employees',
        states: {
            CO: 2,
            IA: 2,
            IL: 2,
            TX: 2
        }
    },
    FLE1: {
        hash: 'Fj4kzxckel1iv',
        name: 'Fletch.co'
    },
    FMA1: {
        hash: 'fma74593d',
        name: 'First & Main',
        states: {
            IL: 2,
            OH: 2,
            MO: 2
        }
    },
    FOUND: {
        hash: 'fffound5',
        name: 'Found It',
        states: {
            AZ: 1,
            CO: 1,
            IA: 1,
            IL: 1,
            IN: 1,
            KY: 1,
            ME: 1,
            MI: 1,
            MO: 1,
            ND: 1,
            NE: 1,
            NH: 1,
            NM: 1,
            OH: 1,
            OK: 1,
            PA: 1,
            SD: 1,
            TX: 1,
            UT: 1,
            VT: 1,
            WI: 1
        }
    },
    FREF1: {
        hash: 'fref1hash',
        name: 'Firefly Agency LLC',
        agency: true
    },
    FW1: {
        hash: 'fopi1o23k',
        name: 'Fairway Independent Mortgage'
    },
    GA0001: {
        hash: 'ga00011hash',
        name: 'Gantz (Chance Kornegay Agency, Inc.)',
        agency: true
    },
    GABI1: {
        hash: 'gabigobble',
        name: 'Gabi',
        agency: true
    },
    GE0001: {
        hash: 'GE0001hash',
        name: 'General Southwest Insurance Agency Inc.',
        agency: true,
        informationId: 'GE0001'
    },
    GF0001: {
        hash: 'gf00011hash',
        agency: true,
        name: 'GFC Insurance, LLC',
        informationId: 'GF0001'
    },
    GH1: {
        hash: 'sdafhg74',
        name: 'Goosehead',
        agency: true,
        serviceAgreement: true,
        ccEmail: 'mailbox@goosehead.com',
        informationId: 'GH1'
    },
    GH2: {
        hash: 'sdafhg742',
        name: 'Goosehead',
        agency: true,
        serviceAgreement: true,
        ccEmail: 'mailbox@goosehead.com',
        informationId: 'GH1'
    },
    GH3: {
        hash: 'sdafhg3742',
        name: 'Goosehead',
        agency: true,
        serviceAgreement: true,
        ccEmail: 'mailbox@goosehead.com',
        informationId: 'GH1'
    },
    GI0002_1: {
        hash: 'GI0002_1hash',
        name: 'Gill Insurance Advisors',
        agency: true,
        disableChat: true,
        informationId: 'GI0002_1'
    },
    GJ0001: {
        hash: 'gj0001hash',
        name: 'GJ Insurance LLC',
        agency: true,
        informationId: 'GJ0001'
    },
    GL0001: {
        hash: 'gl00011hash',
        name: 'Glenn Harris & Associates',
        agency: true,
        informationId: 'GL0001'
    },
    GI0001: {
        hash: 'GI0001hash',
        name: 'Goodman Insurance Solutions',
        agency: true,
        informationId: 'GI0001'
    },
    GI0001P: {
        hash: 'gi0001phash',
        name: 'Goodman Insurance Solutions',
        agency: true,
        informationId: 'GI0001P'
    },
    GN1: {
        name: 'Georgesville Nissan',
        hash: 'axs1s5s5sxw2'
    },
    GR0001: {
        hash: 'gr00011hash',
        name: 'Graziano Lorince Insurance',
        agency: true,
        informationId: 'GR0001'
    },
    GRTRATE: {
        hash: '3kljv90adjc',
        agency: true,
        informationId: 'GRTRATE'
    },
    GRZO1: {
        hash: 'grzo1hash',
        name: 'Graziano Lorince Insurance, LLC',
        agency: true
    },
    GUE0001: {
        hash: 'gue0001hash',
        name: 'Guenette Financial, Inc',
        agency: true
    },
    HA0001: {
        hash: 'ha00011hash',
        agency: true,
        name: 'Harbinson Agency'
    },
    HB0001: {
        hash: 'hb0001phash',
        name: 'Hubbard Insurance Group',
        agency: true
    },
    HA0002_5P: {
        hash: 'HA0002_5Phash',
        name: 'Handzel & Associates LTD',
        agency: true,
        informationId: 'HA0002_5P'
    },
    HB1: {
        hash: 'hbudsfnsa7f65',
        name: 'Heartland Bank',
        states: {
            IN: 1,
            OH: 1,
            OK: 1
        }
    },
    HENNA: {
        name: 'Henna Chevrolet',
        hash: 'gfhenna18g'
    },
    HF0001: {
        hash: 'hf0001phash',
        name: 'Hennessey Financial Services',
        agency: true
    },
    HI0001: {
        hash: 'HI0001hash',
        name: 'Humphries Insurance Group',
        agency: true
    },
    HMPT1: {
        hash: 'hmpta7f65',
        name: 'Homepoint',
        states: {
            AL: 1,
            AZ: 1,
            CO: 1,
            GA: 1,
            IA: 1,
            ID: 1,
            IL: 1,
            IN: 1,
            KS: 1,
            KY: 1,
            MD: 1,
            ME: 1,
            MI: 1,
            MO: 1,
            ND: 1,
            NE: 1,
            NH: 1,
            NJ: 1,
            NM: 1,
            NV: 1,
            NY: 1,
            OH: 1,
            OR: 1,
            OK: 1,
            PA: 1,
            RI: 1,
            SC: 1,
            SD: 1,
            TX: 1,
            UT: 1,
            VA: 1,
            VT: 1,
            WI: 1,
            WV: 1
        }
    },
    HMPT2: {
        hash: 'hmptb319a',
        name: 'Homepoint API',
        states: {
            AL: 1,
            AZ: 1,
            CO: 1,
            GA: 1,
            IA: 1,
            ID: 1,
            IL: 1,
            IN: 1,
            KS: 1,
            KY: 1,
            MD: 1,
            ME: 1,
            MI: 1,
            MO: 1,
            ND: 1,
            NE: 1,
            NH: 1,
            NJ: 1,
            NM: 1,
            NV: 1,
            NY: 1,
            OH: 1,
            OR: 1,
            OK: 1,
            PA: 1,
            RI: 1,
            SC: 1,
            SD: 1,
            TX: 1,
            UT: 1,
            VA: 1,
            VT: 1,
            WI: 1,
            WV: 1
        }
    },
    HMPT3: {
        hash: 'hmpt3jzlk1z',
        name: 'Homepoint Inbound Transfer Call',
        states: {
            AL: 1,
            AZ: 1,
            CO: 1,
            GA: 1,
            IA: 1,
            ID: 1,
            IL: 1,
            IN: 1,
            KS: 1,
            KY: 1,
            MD: 1,
            ME: 1,
            MI: 1,
            MO: 1,
            ND: 1,
            NE: 1,
            NH: 1,
            NJ: 1,
            NM: 1,
            NV: 1,
            NY: 1,
            OH: 1,
            OR: 1,
            OK: 1,
            PA: 1,
            RI: 1,
            SC: 1,
            SD: 1,
            TX: 1,
            UT: 1,
            VA: 1,
            VT: 1,
            WI: 1,
            WV: 1
        }
    },
    HMPT4: {
        hash: 'hmpt3jzlk4z',
        name: 'Homepoint OB Callback',
        states: {
            AL: 1,
            AZ: 1,
            CO: 1,
            GA: 1,
            IA: 1,
            ID: 1,
            IL: 1,
            IN: 1,
            KS: 1,
            KY: 1,
            MD: 1,
            ME: 1,
            MI: 1,
            MO: 1,
            ND: 1,
            NE: 1,
            NH: 1,
            NJ: 1,
            NM: 1,
            NV: 1,
            NY: 1,
            OH: 1,
            OR: 1,
            OK: 1,
            PA: 1,
            RI: 1,
            SC: 1,
            SD: 1,
            TX: 1,
            UT: 1,
            VA: 1,
            VT: 1,
            WI: 1,
            WV: 1
        }
    },
    HMPT5: {
        hash: 'hmpt3jzlk5z',
        name: 'Homepoint Monthly Mailer',
        states: {
            AL: 1,
            AZ: 1,
            CO: 1,
            GA: 1,
            IA: 1,
            ID: 1,
            IL: 1,
            IN: 1,
            KS: 1,
            KY: 1,
            MD: 1,
            ME: 1,
            MI: 1,
            MO: 1,
            ND: 1,
            NE: 1,
            NH: 1,
            NJ: 1,
            NM: 1,
            NV: 1,
            NY: 1,
            OH: 1,
            OR: 1,
            OK: 1,
            PA: 1,
            RI: 1,
            SC: 1,
            SD: 1,
            TX: 1,
            UT: 1,
            VA: 1,
            VT: 1,
            WI: 1,
            WV: 1
        }
    },
    HMPTE: {
        hash: 'hmpte319a',
        name: 'Homepoint Employees',
        states: {
            AZ: 2,
            IA: 2,
            ID: 2,
            ME: 2,
            MI: 2,
            ND: 2,
            NE: 2,
            NH: 2,
            NM: 2,
            SD: 2,
            TX: 2,
            VT: 2
        }
    },
    HOME1: {
        hash: 'home1hash',
        name: 'Homeowners Insurance Group',
        agency: true
    },
    HOMER: {
        name: 'Homer Lending',
        hash: 'fjo39zlkjlz2'
    },
    HOP: {
        name: 'Hopper Motorplex',
        hash: 'gf5shopg'
    },
    HR1: {
        hash: 'NHMvhrrKMSmTL',
        name: 'HR Benefits'
    },
    HRZ: {
        hash: 'hrz533',
        agency: true,
        serviceAgreement: true,
        name: 'HRZ',
        disableChat: true
    },
    HTAP: {
        name: 'Hometap',
        hash: 'htpdfds5',
        states: {
            AZ: 1,
            IA: 1,
            ID: 1,
            IN: 1,
            ME: 1,
            MI: 1,
            ND: 1,
            NE: 1,
            NH: 1,
            NM: 1,
            SD: 1,
            TX: 1,
            VT: 1
        }
    },
    HUWL1: {
        hash: 'huwl1hash',
        name: 'Huwel Insurance Agency',
        agency: true
    },
    HVSU1: {
        hash: 'hvsu1hash',
        name: 'Havasu Insurance',
        agency: true
    },
    HWBC: {
        name: 'Hugh White Buick Chevy',
        hash: 'gf5chwbcd98g'
    },
    IA0001: {
        hash: 'IA0001hash',
        name: 'The Insurance Advisor Group',
        agency: true
    },
    IAL1: {
        hash: 'ial1hash',
        agency: true,
        name: 'IAL Insurance'
    },
    IB0001: {
        hash: 'IB0001hash',
        agency: true,
        name: 'Insurance Brokers Group LLC'
    },
    ID0001: {
        hash: 'ID0001hash',
        name: 'IDEAL Solutions Insurance Services',
        agency: true,
        disableChat: true,
        informationId: 'ID0001'
    },
    IF_10: {
        hash: 'IF_10hash',
        name: 'Integrity 1st, INC DBA Integrity First Insurance'
    },
    IL1: {
        hash: 'NHMv4jkPqrKMSmTL',
        name: 'iLendingDIRECT',
        states: {
            AZ: 1,
            CO: 1,
            IA: 1,
            IL: 1,
            IN: 1,
            KY: 1,
            ME: 1,
            MI: 1,
            MO: 1,
            ND: 1,
            NE: 1,
            NH: 1,
            NM: 1,
            OH: 1,
            OK: 1,
            SD: 1,
            TX: 1,
            UT: 1,
            VT: 1,
            WI: 1
        }
    },
    IN1: {
        hash: 'ind79f',
        agency: true,
        serviceAgreement: true,
        name: 'Insurify',
        informationId: 'IN1'
    },
    IN0002: {
        hash: 'in00021hash',
        agency: true,
        name: 'Integrity First Insurance Services',
        informationId: 'IN0002'
    },
    IN0003: {
        hash: 'IN0003hash',
        name: 'Insurance Professional Agency INC',
        agency: true,
        disableChat: true,
        informationId: 'IN0003'
    },
    INSMRT1: {
        hash: 'insmmmm',
        name: 'Insuremart, Inc.',
        agency: true,
        serviceAgreement: true,
        disableChat: true,
        informationId: 'INSMRT1'
    },
    INT: {
        hash: 'intd79f',
        agency: true,
        serviceAgreement: true,
        name: 'Integra Insurance Solutions'
    },
    INT27P: {
        hash: 'int27phash',
        name: 'Montgomery Integra',
        agency: true,
        informationId: 'INT27P'
    },
    INT0001_1: {
        hash: 'int0001_1hash',
        name: 'Integrity First Insurance Services',
        agency: true
    },
    IP0002: {
        hash: 'IP0002hash',
        name: 'iProtect Insurance & Financial Services, Inc.',
        agency: true,
        disableChat: true,
        informationId: 'IP0002'
    },
    ISI0001: {
        hash: 'ISI0001hash',
        name: 'Indy Select Insurance',
        agency: true
    },
    ISG7P: {
        hash: 'ISG7Phash',
        name: 'Alabama Insurance Markets',
        agency: true,
        informationId: 'ISG7P'
    },
    INSP1: {
        hash: 'dfsjkga678',
        name: 'Inspectify'
    },
    INSTM1: {
        hash: 'instm1hash',
        agency: true,
        name: 'The Insurance Team'
    },
    IOA0001: {
        hash: 'ioa0001hash',
        name: 'Simply IOA',
        agency: true,
        disableChat: true,
        informationId: 'IOA0001'
    },
    IY1: {
        hash: 'iewmvds532',
        agency: true,
        serviceAgreement: true,
        name: 'Insuredly',
        informationId: 'IY1',
        disableChat: true
    },
    IY2: {
        hash: 'iewmvds533',
        agency: true,
        serviceAgreement: true,
        name: 'Insuredly',
        informationId: 'IY1',
        disableChat: true
    },
    IY3: {
        hash: 'iewmvds534',
        agency: true,
        serviceAgreement: true,
        name: 'Insuredly',
        informationId: 'IY1',
        disableChat: true
    },
    IY4: {
        hash: 'iewmvds5354',
        agency: true,
        serviceAgreement: true,
        name: 'Insuredly',
        informationId: 'IY1',
        disableChat: true
    },
    IY5: {
        hash: 'iewmvds53554',
        agency: true,
        serviceAgreement: true,
        name: 'Insuredly',
        informationId: 'IY1',
        disableChat: true
    },
    JC1: {
        hash: 'iewjjc53',
        agency: true,
        serviceAgreement: true,
        name: 'JC Smith Insurance',
        informationId: 'JC1'
    },
    JCBS1: {
        hash: 'jcbs1hash',
        name: 'Jacobs Insurance Solutions',
        agency: true
    },
    JD1: {
        hash: 'dfsjkvjd1',
        agency: true,
        serviceAgreement: true,
        name: 'Jared Reynolds Insurance',
        informationId: 'JD1',
        disableChat: true
    },
    JE0001: {
        hash: 'je00011hash',
        name: 'Jacobs Insurance Solutions',
        agency: true
    },
    JE0002_1: {
        hash: 'JE0002_1hash',
        name: 'Jeff Johnson Agency',
        agency: true,
        disableChat: true,
        informationId: 'JE0002_1'
    },
    JI0001: {
        hash: 'ji00011hash',
        name: 'JIM HORNE INSURANCE AGENCY,INC',
        agency: true
    },
    JL1: {
        hash: 'iewjlllds53',
        name: 'Jennifer Lombardo',
        agency: true,
        serviceAgreement: true,
        informationId: 'JL1'
    },
    JL0001_1P: {
        hash: 'JL0001_1Phash',
        name: 'John Letson Insurance Agency',
        agency: true,
        disableChat: true,
        informationId: 'JL0001_1P'
    },
    JLEE1: {
        hash: 'jlee1hash',
        agency: true,
        serviceAgreement: true,
        name: 'John Lee Insurance Agency LLC'
    },
    JO0001: {
        hash: 'jo00011hash',
        agency: true,
        name: 'John Shawareb Agency LLC',
        informationId: 'JO0001'
    },
    JR1: {
        hash: 'iewjrds53',
        name: 'Joseph W. Reeves Insurance',
        agency: true,
        serviceAgreement: true,
        informationId: 'JR1'
    },
    JU0001: {
        hash: 'JU0001hash',
        name: 'Just Protect Insurance',
        agency: true,
        informationId: 'JU0001'
    },
    KC0001: {
        hash: 'KC0001hash',
        name: 'Kcraft Insurance Agency',
        agency: true,
        informationId: 'KC0001'
    },
    KG1: {
        hash: 'dfsakvs7fsdkg',
        name: 'Kangaroo',
        allowRestricted: {
            MI: true
        },
        homeSecurity: true,
        signUpThroughBranch: true
    },
    KG2: {
        hash: 'dfsakvs7fsdkg',
        name: 'Kangaroo',
        allowRestricted: {
            MI: true
        },
        homeSecurity: true,
        signUpThroughBranch: true
    },
    KG3: {
        hash: 'dfsakvs7fsdkg',
        name: 'Kangaroo',
        allowRestricted: {
            MI: true
        },
        homeSecurity: true,
        signUpThroughBranch: true
    },
    KG4: {
        hash: 'dfsakvs7fsdkg',
        name: 'Kangaroo',
        allowRestricted: {
            MI: true
        },
        homeSecurity: true,
        signUpThroughBranch: true
    },
    KLT1: {
        hash: 'kdfuiwft1',
        name: 'KLT Insurance',
        agency: true,
        serviceAgreement: true,
        informationId: 'KLT1',
        disableChat: true
    },
    KLT2: {
        hash: 'kdfuiwft12',
        name: 'KLT Insurance',
        agency: true,
        serviceAgreement: true,
        informationId: 'KLT2',
        disableChat: true
    },
    KM0001: {
        hash: 'KM0001hash',
        name: 'Lorenz Agency LLC',
        agency: true
    },
    KN0001: {
        hash: 'KN0001hash',
        name: 'Knights Insurance Agency',
        agency: true,
        disableChat: true,
        informationId: 'KN0001'
    },
    KORT1: {
        hash: 'kort1hash',
        name: 'Kortsen & Associates LLC',
        agency: true
    },
    KST1: {
        hash: 'M99dVc',
        name: 'Kissterra'
    },
    LA0001: {
        hash: 'la00011hash',
        agency: true,
        name: 'Landmark Risk Management & Insurance'
    },
    LB1: {
        hash: 'ieddsxds53',
        name: 'Liberty Tax',
        states: {
            IN: 0,
            OH: 0
        }
    },
    LBV1: {
        hash: 'lbv1hash',
        name: 'LBV INSURANCE',
        agency: true
    },
    LF0001: {
        hash: 'LF0001hash',
        agency: true,
        name: 'Leggett Insurance & Financial Services Inc. DBA Hapbridge',
        informationId: 'JO0001'
    },
    LG0001: {
        hash: 'LG0001hash',
        name: 'Lagrave Agency Inc.',
        agency: true,
        disableChat: true,
        informationId: 'LG0001'
    },
    LG1: {
        hash: 'fddddsv4d',
        name: 'Lendgo',
        states: {
            AL: 2,
            AZ: 2,
            CO: 2,
            GA: 2,
            IL: 2,
            IN: 2,
            KS: 2,
            KY: 2,
            MD: 2,
            MI: 2,
            MO: 2,
            NE: 2,
            NJ: 2,
            NV: 2,
            NY: 2,
            OH: 2,
            OR: 2,
            OK: 2,
            RI: 2,
            SC: 2,
            TX: 2,
            UT: 2,
            VA: 2,
            WI: 2,
            WV: 2
        }
    },
    LGI1: {
        hash: 'lgsdfdw',
        agency: true,
        serviceAgreement: true,
        name: 'Legacy Insures'
    },
    LOGIC: {
        hash: 'logggic',
        name: 'Logic Auto Sales'
    },
    LOUI1: {
        hash: 'loui1hash',
        name: 'Lou Insurance & Financial Services Inc',
        agency: true
    },
    LNSTR1: {
        hash: 'lnstr1hash',
        name: 'Lone Star Insurers',
        agency: true
    },
    LT0001: {
        hash: 'LT0001hash',
        name: 'The Layton Company',
        agency: true,
        disableChat: true,
        informationId: 'LT0001'
    },
    LW0001P: {
        hash: 'LW0001Phash',
        name: 'Loftis & Wetzel Corp',
        agency: true,
        disableChat: true,
        informationId: 'LW0001P'
    },
    MATIC1: {
        hash: 'maticabs',
        name: 'Matic',
        agency: true
    },
    MA0002_1: {
        hash: 'MA0002_1hash',
        name: 'Matt Witsken LLC',
        agency: true,
        disableChat: true,
        informationId: 'MA0002_1'
    },
    MCR1: {
        hash: 'mcr1hash',
        name: 'Mike Crise Agency',
        agency: true
    },
    MC0001P: {
        hash: 'MC0001Phash',
        name: 'McCluskey Insurance Services Inc.',
        agency: true,
        disableChat: true,
        informationId: 'MC0001P'
    },
    MC0001: {
        hash: 'mc0001hash',
        name: 'McCluskey Insurance Services Inc.',
        agency: true,
        informationId: 'MC0001'
    },
    MCI0001: {
        hash: 'mci0001hash',
        name: 'Magic City Insurance Group, LLC',
        agency: true,
        informationId: 'MCI0001'
    },
    MJ0001: {
        hash: 'MJ0001hash',
        agency: true,
        name: 'MJB Financial & Insurance Advisors',
        informationId: 'MJ0001'
    },
    MI0001: {
        hash: 'mi00011hash',
        name: 'THE MITCHELL AGENCY LLC',
        agency: true
    },
    MIL: {
        hash: 'idnmiltas',
        agency: true,
        serviceAgreement: true,
        name: 'Milnor Insurance',
        informationId: 'MIL'
    },
    MILO1: {
        hash: 'milo1hash',
        name: 'MILOSEVIC INSURANCE AGENCY',
        agency: true
    },
    MMS1: {
        hash: '4mmsssGIA7',
        name: 'Midwest Motor Supply',
        states: {
            AZ: 2,
            IL: 2,
            IN: 2,
            MD: 2,
            MO: 2,
            OH: 2,
            OK: 2,
            TX: 2
        }
    },
    MMTCH1: {
        hash: 'mmtch1hash',
        name: 'Mix & Match Insurance Brokerage LLC',
        agency: true
    },
    MNSTY1: {
        name: 'Mainstay Insurance Agency',
        agency: true,
        serviceAgreement: true,
        hash: 'eui983lamnstyi'
    },
    MQX0001: {
        hash: 'mqx0001phash',
        name: 'MQX LLC',
        agency: true
    },
    MT0001: {
        hash: 'mt0001hash',
        name: 'Mtran Insurance and Associates',
        agency: true
    },
    MTRO1: {
        hash: 'mtro1hash',
        name: 'Metroplex Insurance & Financial Group LLC',
        agency: true
    },
    MVP: {
        name: 'MVP Insurance Agency',
        agency: true,
        serviceAgreement: true,
        hash: 'qe9df91d5jh'
    },
    MWBG: {
        name: 'Mark Wahlberg Buick GMC',
        hash: '8fed6e5er'
    },
    MWC: {
        name: 'Mark Wahlberg Chevy',
        hash: 'qwhj8zd21s'
    },
    MYLO1: {
        hash: 'klzujoi1jk',
        name: 'Mylo Insurance Solutions',
        agency: true
    },
    MY0001_P: {
        hash: 'my0001Phash',
        name: 'My Insurance Agent, Inc',
        agency: true,
        disableChat: true,
        informationId: 'MY0001_P'
    },
    NEX1: {
        hash: 'fdsanexe',
        name: 'Nexar',
        states: {
            AZ: 2,
            CO: 2,
            IA: 2,
            IL: 2,
            IN: 2,
            KY: 2,
            MD: 2,
            ME: 2,
            MI: 2,
            MO: 2,
            ND: 2,
            NE: 2,
            NH: 2,
            OH: 2,
            OK: 2,
            PA: 2,
            SD: 2,
            UT: 2,
            VT: 2,
            WI: 2
        }
    },
    NEXTB1: {
        hash: 'dfvnyds3',
        name: 'Nextbase',
        states: {
            AZ: 2,
            CO: 2,
            IA: 2,
            IL: 2,
            IN: 2,
            KY: 2,
            MD: 2,
            ME: 2,
            MI: 2,
            MO: 2,
            ND: 2,
            NE: 2,
            NH: 2,
            OH: 2,
            OK: 2,
            SD: 2,
            TX: 2,
            UT: 2,
            VT: 2,
            WI: 2
        }
    },
    NI0001: {
        hash: 'ni0001hash',
        name: 'Nicia Insurance',
        agency: true
    },
    NMIB1: {
        hash: 'nmibd33f1',
        agency: true,
        serviceAgreement: true,
        name: 'NMH Insurance Agency',
        informationId: 'NMIB1'
    },
    NMIB2: {
        hash: 'nmib2hash',
        agency: true,
        serviceAgreement: true,
        name: 'NMH Insurance Agency',
        informationId: 'NMIB2'
    },
    NN1: {
        name: 'Nissan North',
        hash: 'ml1dsazd6s4'
    },
    NO0001: {
        hash: 'NO0001hash',
        name: 'North American Insurance Agency of Louisiana, Inc',
        agency: true,
        disableChat: true,
        informationId: 'NO0001'
    },
    NS0001: {
        hash: 'ns0001phash',
        name: 'Nsure Insurance Services Inc.',
        agency: true
    },
    NV0001: {
        hash: 'nv0001hash',
        name: 'Nevada Insurance',
        agency: true
    },
    NV0001P: {
        hash: 'nv0001phash',
        name: 'Nevada Insurance',
        agency: true
    },
    NW1: {
        hash: '4GIA7',
        name: 'NWOSS',
        homeSecurity: true,
        states: {
            IN: 2,
            MD: 2,
            OH: 2,
            OK: 2
        }
    },
    NWE: {
        hash: '4GIA7E',
        name: 'NWOSS',
        homeSecurity: true,
        states: {
            IN: 2,
            OH: 2,
            OK: 2
        }
    },
    NYLE: {
        name: 'Nyle Maxwell CJDR',
        hash: 'gf5nyletg'
    },
    OAC: {
        hash: 'noac33f1',
        agency: true,
        serviceAgreement: true,
        name: 'AAA Ohio Auto Club',
        informationId: 'OAC'
    },
    OBB: {
        hash: 'ruobbiri',
        name: 'Olive Branch Brokerage, LLC',
        agency: true,
        serviceAgreement: true,
        disableChat: true,
        informationId: 'OBB'
    },
    OB0001: {
        hash: 'ob0001hash',
        name: 'OBrien Agency',
        agency: true
    },
    OL0001: {
        hash: 'ol0001hash',
        name: 'Old Line Insurance Agency LLC',
        agency: true
    },
    ON0001: {
        hash: 'on0001hash',
        name: 'OneStop Insurance Solutions LLC',
        agency: true
    },
    ORL1: {
        name: 'OpenRoad Lending',
        hash: '1mq7mds98rf',
        hideFromOffers: true
    },
    ORL2: {
        name: 'OpenRoad Lending',
        hash: '1mq7mds98rf2',
        states: {
            AZ: 1,
            CO: 1,
            IA: 1,
            ID: 1,
            IL: 1,
            IN: 1,
            KY: 1,
            MD: 1,
            ME: 1,
            MI: 1,
            MO: 1,
            ND: 1,
            NE: 1,
            NH: 1,
            NM: 1,
            OH: 1,
            OK: 1,
            SD: 1,
            TX: 1,
            UT: 1,
            VT: 1,
            WI: 1
        }
    },
    ORL3: {
        name: 'OpenRoad Lending',
        hash: '1mq7mds98rf3',
        states: {
            AZ: 1,
            CO: 1,
            IA: 1,
            ID: 1,
            IL: 1,
            IN: 1,
            KY: 1,
            MD: 1,
            ME: 1,
            MI: 1,
            MO: 1,
            ND: 1,
            NE: 1,
            NH: 1,
            NM: 1,
            OH: 1,
            OK: 1,
            SD: 1,
            TX: 1,
            UT: 1,
            VT: 1,
            WI: 1
        }
    },
    ORLE: {
        name: 'OpenRoad Lending Employees',
        hash: '1mq7mds98rfE',
        states: {
            IA: 2,
            TX: 2
        }
    },
    PA0001: {
        hash: 'pa00011hash',
        agency: true,
        name: 'Paragon Insurance'
    },
    PCF0001: {
        hash: 'pcf0001hash',
        name: 'Blue Ridge National',
        agency: true
    },
    PI0001: {
        hash: '12k3jlakzvqenhc',
        agency: true,
        name: 'Pinnacle Insurance'
    },
    PC1: {
        hash: '8dhjv63jndv',
        name: 'Panda ECS',
        states: {
            AZ: 0,
            OH: 0,
            IL: 0,
            IN: 0,
            MO: 0,
            TX: 0
        }
    },
    PCA1: {
        hash: 'pf7chjaca',
        name: 'Protection Connection Agency',
        agency: true
    },
    PCA2: {
        hash: 'pf7chjaca2',
        name: 'Protection Connection Agency',
        agency: true
    },
    PCJD: {
        name: 'Performance Chrysler Jeep Dodge',
        hash: 'fds46nuw332'
    },
    PI1: {
        hash: 'pi77dd',
        name: 'Partner Insurance',
        agency: true,
        serviceAgreement: true,
        informationId: 'PI1'
    },
    PG0001: {
        hash: 'pg00011hash',
        agency: true,
        name: 'Pagel Insurance'
    },
    PMC: {
        hash: 'dfsjiopdmp',
        name: 'Protect My Car',
        informationId: 'PMC'
    },
    PN0001: {
        hash: 'PN0001hash',
        name: 'Pinnacle Insurance and Investments',
        agency: true,
        informationId: 'PN0001'
    },
    PN0001P: {
        hash: 'PN0001Phash',
        name: 'Pinnacle Insurance & Investment',
        agency: true,
        disableChat: true,
        informationId: 'PN0001P'
    },
    PO0001: {
        hash: 'PO0001hash',
        name: 'ProWest Insurance Group',
        agency: true,
        disableChat: true,
        informationId: 'PO0001'
    },
    PO0001P: {
        hash: 'PO0001Phash',
        name: 'ProWest Insurance Group',
        agency: true,
        disableChat: true,
        informationId: 'PO0001P'
    },
    PRTL1: {
        hash: 'prtl1hash',
        name: 'Portal, LLC',
        agency: true
    },
    PRM1: {
        hash: 'prm1hash',
        name: 'Priority Risk Management',
        agency: true
    },
    PUP1: {
        hash: 'pup58df',
        name: 'Puptown Lounge',
        states: {
            OH: 2
        }
    },
    PVI0001: {
        hash: 'PVI0001hash',
        name: 'Providence Insurance',
        agency: true
    },
    PVD1: {
        hash: 'pdjvdspvd1',
        name: 'Provide Financial',
        informationId: 'PVD1'
    },
    PX1: {
        hash: 'fdsklbvudpx',
        name: 'PX'
    },
    QAONLINE: {
        hash: 'qaodlneid',
        agency: true,
        serviceAgreement: true,
        name: 'Quantum Assurance Online',
        informationId: 'QAONLINE'
    },
    QB0001: {
        hash: 'QB0001hash',
        agency: true,
        name: 'QB Insurance LLC',
        informationId: 'QB0001'
    },
    QI1: {
        hash: 'qifdsnkl;734nd',
        agency: true,
        serviceAgreement: true,
        name: 'QuickInsured',
        informationId: 'QI1'
    },
    QI2: {
        hash: 'qifdsnkl;734nd22',
        name: 'QuickInsured',
        agency: true,
        serviceAgreement: true,
        informationId: 'QI2'
    },
    QL1: {
        hash: '6Tpye',
        name: 'Rocket Mortgage',
        shouldBeNotified: true,
        mortgageLender: true,
        featuredProvider: true,
        states: {
            AL: 2,
            AZ: 2,
            CO: 2,
            GA: 2,
            IA: 2,
            ID: 1,
            IL: 2,
            IN: 2,
            KS: 2,
            KY: 2,
            MD: 2,
            ME: 2,
            MI: 2,
            MO: 2,
            ND: 2,
            NE: 2,
            NH: 2,
            NJ: 2,
            NM: 2,
            NV: 2,
            NY: 2,
            OH: 2,
            OR: 2,
            OK: 2,
            RI: 2,
            SC: 2,
            SD: 2,
            TX: 2,
            UT: 2,
            VA: 2,
            VT: 2,
            WI: 2,
            WV: 2
        }
    },
    QLE: {
        hash: '6TpyeE',
        name: 'Rocket Mortgage',
        shouldBeNotified: true,
        mortgageLender: true,
        featuredProvider: true,
        states: {
            AL: 2,
            AZ: 2,
            CO: 2,
            GA: 2,
            IA: 2,
            ID: 1,
            IL: 2,
            IN: 2,
            KS: 2,
            KY: 2,
            MD: 2,
            ME: 2,
            MI: 2,
            MO: 2,
            ND: 2,
            NE: 2,
            NH: 2,
            NJ: 2,
            NM: 2,
            NV: 2,
            NY: 2,
            OH: 2,
            OR: 2,
            OK: 2,
            RI: 2,
            SC: 2,
            SD: 2,
            TX: 2,
            UT: 2,
            VA: 2,
            VT: 2,
            WI: 2,
            WV: 2
        }
    },
    QWZ1: {
        hash: 'f90o1ljlsxk',
        name: 'QuoteWizard'
    },
    QWZS: {
        hash: 'QWZShash',
        name: 'Quote Wizard Solutions',
        agency: true,
        informationId: 'QWZS'
    },
    QWZE: {
        hash: 'QWZEhash',
        name: 'Quote Wizard Solutions',
        agency: true,
        informationId: 'QWZE'
    },
    RC0001P: {
        hash: 'RC0001Phash',
        name: 'Rich & Cartmill',
        agency: true,
        informationId: 'RC0001P'
    },
    RACE: {
        hash: 'dsfsd8ewf',
        name: 'Race Day Mortgage',
        states: {
            OH: 1
        }
    },
    RDRS1: {
        hash: 'rdrs1hash',
        name: 'Red Rose Insurance LLC',
        agency: true
    },
    RGD1: {
        hash: 'rgd1hash',
        name: 'Renegade Insurance LLC',
        agency: true
    },
    RGTLP1: {
        hash: 'rgtlp1hash',
        name: 'Reliance Group Texas, L.P.',
        agency: true,
        serviceAgreement: true,
        informationId: 'RGTLP1'
    },
    RH1: {
        name: 'Roush Honda',
        hash: 'gf5rh1d98g'
    },
    RHBS1: {
        hash: 'rhbs1hash',
        name: 'R Hobbs Insurance Agency Inc',
        agency: true
    },
    RI1: {
        hash: 'rutldiri',
        name: 'Rutledge Insurance Group',
        agency: true,
        serviceAgreement: true,
        informationId: 'RI1'
    },
    RIC1: {
        name: 'Ricart Auto',
        informationId: 'RIC1',
        hash: 'gf5su6dd98g'
    },
    RL0001: {
        hash: 'rl00011hash',
        name: 'RLTI Family Insurance',
        agency: true,
        informationId: 'RL0001'
    },
    RM1: {
        hash: 'iwp1y',
        name: 'Revolution Mortgage',
        mortgageLender: true,
        mortgageClause: 'RM1',
        splitLeadID: true,
        allowRestricted: {
            MI: true
        },
        states: {
            AL: 2,
            CO: 2,
            IA: 2,
            ID: 2,
            IN: 2,
            KS: 2,
            KY: 2,
            MD: 2,
            NM: 2,
            OH: 2,
            OK: 2,
            PA: 2,
            TX: 2,
            UT: 2,
            VA: 2,
            WI: 2,
            WV: 2
        }
    },
    RM2: {
        hash: 'iwp2y',
        name: 'Revolution Mortgage',
        mortgageLender: true,
        mortgageClause: 'RM1',
        splitLeadID: true,
        allowRestricted: {
            MI: true
        },
        states: {
            AL: 2,
            CO: 2,
            ID: 2,
            IN: 2,
            KS: 2,
            KY: 2,
            MD: 2,
            NM: 2,
            OH: 2,
            OK: 2,
            PA: 2,
            TX: 2,
            UT: 2,
            VA: 2,
            WI: 2,
            WV: 2
        }
    },
    RME: {
        hash: 'iwp1yE',
        name: 'Revolution Mortgage',
        mortgageLender: true,
        mortgageClause: 'RM1',
        splitLeadID: true,
        allowRestricted: {
            MI: true
        },
        states: {
            AL: 2,
            CO: 2,
            ID: 2,
            IN: 2,
            KS: 2,
            KY: 2,
            MD: 2,
            NM: 2,
            OH: 2,
            OK: 2,
            PA: 2,
            TX: 2,
            UT: 2,
            VA: 2,
            WI: 2,
            WV: 2
        }
    },
    ROGRSK1: {
        hash: 'rogrsk1hash',
        name: 'Rogue Risk LLC',
        agency: true
    },
    ROND1_1: {
        hash: 'rond1_1hash',
        name: 'Rondon Insurance Services',
        agency: true
    },
    ROND1_2: {
        hash: 'rond1_2hash',
        name: 'Rondon Insurance Services',
        agency: true
    },
    ROND1_3: {
        hash: 'rond1_3hash',
        name: 'Rondon Insurance Services',
        agency: true
    },
    ROND1_4: {
        hash: 'rond1_4hash',
        name: 'Rondon Insurance Services',
        agency: true
    },
    ROND1_5: {
        hash: 'rond1_5hash',
        name: 'Rondon Insurance Services',
        agency: true
    },
    ROND1_6: {
        hash: 'rond1_6hash',
        name: 'Rondon Insurance Services',
        agency: true
    },
    ROND1: {
        hash: 'rond1hash',
        name: 'Rondon Insurance Services',
        agency: true
    },
    ROYLT1: {
        hash: 'roylt1hash',
        name: 'Royalty Insurance Agency',
        agency: true
    },
    RS1: {
        hash: 'sd9nver89',
        name: "Ritchie's Security"
    },
    RSWL1: {
        hash: 'rswl1hash',
        name: 'RiskWell',
        agency: true
    },
    RVE: {
        hash: 'klfdsuiwef8',
        name: 'RevelIT',
        states: {
            AZ: 2,
            IL: 2,
            IN: 2,
            MD: 2,
            MO: 2,
            OH: 2,
            OK: 2,
            PA: 2,
            TX: 2
        }
    },
    SA1: {
        name: 'Superior Auto',
        hash: '17sdad97gh7e'
    },
    SALTY: {
        hash: 'saltY4d',
        name: 'Salty',
        agency: true,
        serviceAgreement: true,
        skipScheduledCall: true
    },
    SAS1: {
        hash: 'dfkjvfusad87sas',
        name: 'Shook Auto Sales'
    },
    SE0002: {
        hash: 'SE0002hash',
        name: 'Sessions Insurance',
        agency: true,
        serviceAgreement: true,
        informationId: 'SE0002'
    },
    SE0002P: {
        hash: 'SE0002Phash',
        name: 'Sessions Insurance',
        agency: true,
        serviceAgreement: true,
        informationId: 'SE0002P'
    },
    SGIA1: {
        hash: 'SGIA1hash',
        agency: true,
        serviceAgreement: true,
        name: 'Southern Group Insurance Agency, Inc.'
    },
    SHP1: {
        hash: 'shp3789jv7d',
        name: 'Shepherd Insurance',
        agency: true
    },
    SI1: {
        hash: 'dugrndk5',
        agency: true,
        serviceAgreement: true,
        name: 'Obie',
        informationId: 'SI1'
    },
    SI2: {
        hash: 'dugrndk5',
        name: 'Obie',
        agency: true,
        serviceAgreement: true,
        informationId: 'SI1'
    },
    SI0001: {
        hash: 'SI0001hash',
        name: 'Strong Insurance Inc.',
        agency: true
    },
    SIG1: {
        hash: 'ddfdsiwesdmd',
        name: 'Steven Insurance Group'
    },
    SIGM1: {
        hash: 'dfkl44sdfisg',
        name: 'Signature Mortgage',
        allowRestricted: {
            MI: true
        },
        states: {
            CO: 2,
            IN: 2,
            OH: 2,
            TX: 2
        }
    },
    SIM1: {
        hash: 'sim1hash',
        name: 'Simply Insured, LLC',
        agency: true
    },
    SIMIOA1: {
        hash: 'ckeviuenvujyhibvy',
        name: 'Simply IOA'
    },
    SIMPLY1: {
        hash: 'sbnid134',
        name: 'SimpliSafe',
        informationId: 'SIMPLY1',
        homeSecurity: true,
        signUpThroughBranch: true
    },
    SKYLGHT1: {
        hash: 'dkfdhksd',
        agency: true,
        serviceAgreement: true,
        name: 'Skylight Insurance',
        informationId: 'SKYLGHT1'
    },
    SMAFIN1: {
        name: 'SmartFinancial',
        hash: 'cjliej1290clkj'
    },
    SMAZ: {
        hash: 'dfskazxusscs',
        name: 'SmartChoice AZ',
        agency: true,
        serviceAgreement: true,
        informationId: 'SMAZ'
    },
    SMAZ02: {
        hash: 'smaz021hash',
        name: 'Safe Harbor Insurance',
        agency: true
    },
    SMAZ8P: {
        hash: 'SMAZ8Phash',
        name: 'Wishwell Insurance Brokers',
        agency: true,
        disableChat: true,
        informationId: 'SMAZ8P'
    },
    SMIN: {
        hash: 'dfskincxusscs',
        name: 'SmartChoice IN',
        agency: true,
        serviceAgreement: true,
        informationId: 'SMIN'
    },
    SMMI1: {
        hash: 'smmi1hash',
        name: 'Clement Insurance, LLC',
        agency: true
    },
    SMOH: {
        hash: 'dfskj;vcxusscs',
        name: 'SmartChoice',
        agency: true
    },
    SMOK: {
        hash: 'dfskiokusscs',
        name: 'SmartChoice OK',
        agency: true,
        serviceAgreement: true,
        informationId: 'SMOK'
    },
    SMRT1: {
        hash: 'smrt1hash',
        name: 'Smart Insured Solutions, LLC',
        agency: true
    },
    SMTN5P: {
        hash: 'SMTN5Phash',
        name: 'Dekalb County Insurance',
        agency: true,
        disableChat: true,
        informationId: 'SMTN5P'
    },
    SMTN9P: {
        hash: 'SMTN9Phash',
        name: 'Middle TN Insurance Group',
        agency: true,
        informationId: 'SMTN9P'
    },
    SMTX: {
        hash: 'intd79f',
        agency: true,
        serviceAgreement: true,
        name: 'SmartChoice Texas'
    },
    SMWI3P: {
        hash: 'SMWI3Phash',
        name: 'Harper Tax & Financial Literacy',
        agency: true,
        informationId: 'SMWI3P'
    },
    SMUN1: {
        hash: 'smun1hash',
        name: 'Smart Universal Insurance',
        agency: true
    },
    SS0002_2: {
        hash: 'SS0002_2hash',
        name: 'S&S Insurance Services, Inc.',
        agency: true,
        serviceAgreement: true,
        informationId: 'SS0002_2'
    },
    SS0002_1: {
        hash: 'SS0002_1hash',
        name: 'S&S Insurance Services, Inc.',
        agency: true,
        serviceAgreement: true,
        informationId: 'SS0002_1'
    },
    SUN0001: {
        hash: 'SUN0001hash',
        name: 'Sunnyside Insurance Agency LLC',
        agency: true,
        informationId: 'SUN0001'
    },
    SYNC: {
        hash: 'syncash',
        name: 'SYNC'
    },
    TAC0001_15P: {
        hash: 'TAC0001_15Phash',
        name: 'Guardian Insurance Partners, LLC',
        agency: true,
        informationId: 'TAC0001_15P'
    },
    TAC0001_20P: {
        hash: 'TAC0001_20Phash',
        name: 'The Churchill Agency',
        agency: true,
        informationId: 'TAC0001_20P'
    },
    TAP1: {
        name: 'Hometap',
        hash: 'htpdfds5',
        states: {
            AZ: 1,
            IA: 1,
            ID: 1,
            IN: 1,
            ME: 1,
            MI: 1,
            ND: 1,
            NE: 1,
            NH: 1,
            NM: 1,
            SD: 1,
            TX: 1,
            VT: 1
        }
    },
    TAS: {
        hash: 'idnfusitas',
        name: 'Insuritas',
        agency: true,
        serviceAgreement: true,
        informationId: 'TAS'
    },
    TAS2: {
        hash: 'idnfusitas2',
        name: 'Insuritas',
        agency: true,
        serviceAgreement: true,
        informationId: 'TAS'
    },
    TATUM1: {
        hash: '3kjs9tatum1',
        agency: true,
        serviceAgreement: true,
        informationId: 'TATUM1'
    },
    TATUM2: {
        hash: '3kjs9tatum2',
        agency: true,
        serviceAgreement: true,
        informationId: 'TATUM2'
    },
    TATUM3: {
        hash: '3kjs9tatum3',
        agency: true,
        serviceAgreement: true,
        informationId: 'TATUM3'
    },
    TBDS1: {
        hash: 'tbds1hash',
        name: 'Tisha Brandes Insurance Services LLC',
        agency: true
    },
    TBG: {
        name: 'Twins Buick GMC',
        hash: '8eqwi9sd4fg5'
    },
    TC0001: {
        hash: 'TC0001hash',
        name: 'TCDS Insurance Agency',
        agency: true,
        informationId: 'TC0001'
    },
    TC1: {
        hash: 'Riumk',
        name: 'Total Choice',
        mortgageLender: true,
        states: {
            IN: 2,
            MD: 2,
            OH: 2,
            OK: 2
        }
    },
    TCP: {
        name: 'Toyota of Cedar Park',
        hash: 'gf5stcptg'
    },
    TCP1: {
        hash: 'tcp1hash',
        name: 'The Coverage Pro',
        agency: true
    },
    TEST: {
        hash: 'test',
        name: 'Test Agency',
        shouldBeNotified: true,
        agency: true,
        serviceAgreement: true,
        informationId: 'TEST'
    },
    TEST1: {
        hash: 'test1',
        name: 'Test Agency 1',
        shouldBeNotified: true,
        agency: true,
        serviceAgreement: true,
        informationId: 'TEST1'
    },
    TEST2: {
        hash: 'test2',
        name: 'Test Agency 2',
        shouldBeNotified: true,
        agency: true,
        serviceAgreement: true,
        informationId: 'TEST2'
    },
    TEST3: {
        hash: 'test3',
        name: 'Test Agency 3',
        shouldBeNotified: true,
        agency: true,
        serviceAgreement: true,
        informationId: 'TEST3'
    },
    TEST4: {
        hash: 'test4',
        name: 'Test Agency 4',
        shouldBeNotified: true,
        agency: true,
        serviceAgreement: true,
        informationId: 'TEST4'
    },
    TEST5: {
        hash: 'test5',
        name: 'Test Agency 5',
        shouldBeNotified: true,
        agency: true,
        serviceAgreement: true,
        informationId: 'TEST5'
    },
    TC0001P: {
        hash: 'TC0001Phash',
        name: 'TCDS Insurance Agency',
        agency: true,
        serviceAgreement: true,
        informationId: 'TC0001P'
    },
    TCE: {
        hash: 'RiumkE',
        name: 'Total Choice',
        mortgageLender: true,
        states: {
            IN: 2,
            MD: 2,
            OH: 2,
            OK: 2
        }
    },
    TGS1: {
        hash: 'tgs1hash',
        name: 'TGS Insurance Agency',
        agency: true
    },
    TH0001: {
        hash: 'th00011hash',
        name: 'Thomas J Robinson Insurance',
        agency: true
    },
    THRV1: {
        hash: 'thrv1hash',
        name: 'Thrive Insurance',
        agency: true
    },
    TI0001_1P: {
        hash: 'TI0001_1Phash',
        name: 'The Insurance Alliance',
        agency: true,
        serviceAgreement: true,
        informationId: 'TI0002'
    },
    TI0002: {
        hash: 'TI0002hash',
        name: 'Turbo Insurance Group LLC',
        agency: true,
        serviceAgreement: true,
        informationId: 'TI0002'
    },
    TI0002P: {
        hash: 'TI0002Phash',
        name: 'Turbo Insurance Group LLC',
        agency: true,
        serviceAgreement: true,
        informationId: 'TI0002P'
    },
    TLY1: {
        hash: 'zAn63Z8emHffr6Wv',
        name: 'Transparent.ly'
    },
    TP0001: {
        hash: 'TP0001hash',
        name: 'The Portner Agency',
        agency: true
    },
    TRELC: {
        hash: 'f9trelcc',
        name: 'Trellis Connect',
        agency: true,
        serviceAgreement: true,
        disableChat: true
    },
    TRESL1: {
        name: 'Tresl',
        informationId: 'TRESL1',
        hash: 'treslhash',
        allowRestricted: {
            MI: true
        }
    },
    TR0001: {
        hash: 'TR0001hash',
        name: 'Trailstone Insurance Group',
        agency: true,
        informationId: 'TR0001'
    },
    TR0002: {
        hash: 'TR0002hash',
        name: 'Truly Insurance',
        agency: true,
        informationId: 'TR0002'
    },
    TT0001: {
        hash: 'tt00011hash',
        name: '235 Insurance',
        agency: true
    },
    TW0001: {
        hash: 'tw00011hash',
        name: 'V&A Multiservices and Associates',
        agency: true
    },
    TXCL1: {
        hash: 'txcl1hash',
        name: 'Texas Classic Insurance',
        agency: true
    },
    UB1: {
        hash: 'dfdsk8e',
        name: 'Unbiased Auto',
        states: {
            TX: 2
        }
    },
    UN0001: {
        hash: 'UN0001hash',
        name: 'United Insurance and Risk Management',
        agency: true,
        informationId: 'UN0001'
    },
    UNQ1: {
        hash: 'unq1hash',
        agency: true,
        name: 'Unique Insurance Agency LLC'
    },
    UPF1: {
        hash: '3kjlsdklcth',
        name: 'Upfront',
        allowRestricted: {
            MI: true
        }
    },
    UR1: {
        hash: 'YQfPs',
        name: 'Upside Roofing',
        states: {
            IN: 2,
            MD: 2,
            OH: 2,
            OK: 2
        }
    },
    UTYA1P: {
        hash: 'utya1phash',
        name: 'Unity AIA',
        agency: true,
        informationId: 'UTYA1P'
    },
    UTYA1: {
        hash: 'utya1hash',
        name: 'Unity AIA',
        agency: true,
        informationId: 'UTYA1'
    },
    URE: {
        hash: 'YQfPsE',
        name: 'Upside Roofing',
        states: {
            IN: 2,
            MD: 2,
            OH: 2,
            OK: 2
        }
    },
    VA0001: {
        hash: 'va00011hash',
        name: 'V&A Multiservices and Associates LLC',
        agency: true
    },
    VENS1: {
        hash: 'VENS1hash',
        agency: true,
        serviceAgreement: true,
        name: 'Venus Insurance Group'
    },
    VI1: {
        hash: 'vi3dfklv8',
        name: 'Voldico Insurance',
        agency: true
    },
    VILLAGE: {
        hash: 'vidfsiewf',
        name: 'Village Ford',
        informationId: 'VILLAGE'
    },
    VGHN1: {
        hash: 'vghn1hash',
        name: 'Vaughan Insurance Agency LLC',
        agency: true
    },
    VM1: {
        hash: 'TSjFy',
        name: 'Victory Mortgage',
        states: {
            IN: 2,
            MD: 2,
            OH: 2,
            OK: 2
        }
    },
    VME: {
        hash: 'TSjFyE',
        name: 'Victory Mortgage',
        states: {
            IN: 2,
            MD: 2,
            OH: 2,
            OK: 2
        }
    },
    VNZLA: {
        hash: 'ciconzds92',
        name: 'Vonzella',
        agency: true,
        serviceAgreement: true,
        disableChat: true
    },
    VS1: {
        hash: 'dd8y4R',
        name: 'Vector Security',
        homeSecurity: true,
        states: {
            IN: 2,
            MD: 2,
            OH: 2,
            OK: 2
        }
    },
    VSE: {
        hash: 'dd8y4RE',
        name: 'Vector Security',
        homeSecurity: true,
        states: {
            IN: 2,
            MD: 2,
            OH: 2
        }
    },
    VIV1: {
        hash: 's2LPmaa',
        name: 'Vivint Smart Home Agency',
        agency: true,
        serviceAgreement: true,
        informationId: 'VIV1',
        skipScheduledCall: true
    },
    VV1: {
        hash: 'FuNUN',
        name: 'Vivint Smart Home',
        homeSecurity: true,
        achWildcard: true,
        skipScheduledCall: true,
        states: {
            AZ: 2,
            IL: 2,
            IN: 2,
            MD: 2,
            MO: 2,
            OH: 2,
            TX: 2
        },
        informationId: 'VV1'
    },
    VV2: {
        hash: 's2LPm',
        name: 'Vivint Smart Home',
        homeSecurity: true,
        achWildcard: true,
        skipScheduledCall: true,
        disableChat: true,
        states: {
            CO: 2,
            IL: 2,
            IN: 2,
            MD: 2,
            MO: 2,
            OH: 2
        },
        informationId: 'VV1'
    },
    VV3: {
        hash: 's2LPm4',
        name: 'Vivint Smart Home',
        homeSecurity: true,
        skipScheduledCall: true,
        disableChat: true,
        states: {
            AL: 2,
            AZ: 2,
            CO: 2,
            GA: 2,
            IA: 2,
            ID: 2,
            IL: 2,
            IN: 2,
            KS: 2,
            KY: 2,
            MD: 2,
            ME: 2,
            MI: 2,
            MO: 2,
            ND: 2,
            NE: 2,
            NH: 2,
            NJ: 2,
            NM: 2,
            NV: 2,
            NY: 2,
            OH: 2,
            OR: 2,
            OK: 2,
            RI: 2,
            SC: 2,
            SD: 2,
            TX: 2,
            UT: 2,
            VA: 2,
            VT: 2,
            WI: 2,
            WV: 2
        },
        informationId: 'VV1'
    },
    VVE: {
        hash: 's2LPmE',
        name: 'Vivint Smart Home',
        homeSecurity: true,
        skipScheduledCall: true,
        states: {
            IL: 2,
            IN: 2,
            MO: 2,
            OH: 2
        },
        informationId: 'VV1'
    },
    VW0001: {
        hash: 'vw00011hash',
        name: 'Vowels Insurance Agency',
        agency: true
    },
    WAY119: {
        hash: 'WAY119hash',
        name: 'Way.com Insurance Solutions',
        informationId: 'WAY119'
    },
    WA0001: {
        hash: 'wa00011hash',
        name: 'Waterton Insurance Group LLC',
        agency: true
    },
    WC0001: {
        hash: 'wC0001hash',
        name: 'Windy City Insurance Group',
        agency: true
    },
    WCI1: {
        hash: 'wci1hash',
        name: 'White Clay Insurance',
        agency: true
    },
    WEA: {
        hash: '918ikjlkj12',
        name: 'Westerville Education Association',
        states: {
            OH: 2
        }
    },
    WEC1: {
        hash: 'dcwec1fisg',
        name: 'WEC Energy Group',
        states: {
            IL: 2,
            IN: 2,
            WI: 2
        }
    },
    WIF1: {
        hash: 'dafrwfg56',
        name: 'What If Media'
    },
    WIT1: {
        hash: 'wit1hash',
        name: 'We Insure Things',
        agency: true
    },
    WIT2: {
        hash: 'wit2hash',
        name: 'Mirage Insurance',
        agency: true
    },
    WLGS1: {
        hash: 'wlgs1hash',
        name: 'Wilgus Insurance Agency Inc.',
        agency: true
    },
    WN0001: {
        hash: 'wn00011hash',
        name: 'Wynn Insurance Network',
        agency: true
    },
    WP1: {
        hash: 'dafrwp16',
        name: 'Waypoint Benefits'
    },
    WSTX1: {
        hash: 'wstx1hash',
        name: 'West Texas Insurance Agency',
        agency: true
    },
    WXFRD1: {
        hash: 'wxfrd1hash',
        agency: true,
        name: 'Wexford Insurance, LLC'
    },
    WYL1: {
        hash: 'dfkjvfusad87',
        name: 'Wyler'
    },
    YA: {
        hash: 'younaldef',
        name: 'Young Alfred',
        agency: true,
        serviceAgreement: true,
        informationId: 'YA1'
    },
    YA1: {
        hash: 'younaldef',
        name: 'Young Alfred',
        agency: true,
        serviceAgreement: true,
        informationId: 'YA1'
    },
    EXEC1: {
        hash: '98vlkjwdv',
        agency: true
    },
    YL0001: {
        hash: 'yl0001hash',
        name: 'Your Life Protect LLC',
        agency: true,
        informationId: 'YL0001'
    },
    YL0001P: {
        hash: 'YL0001Phash',
        name: 'Your Life Protect LLC',
        agency: true,
        serviceAgreement: true,
        informationId: 'YL0001P'
    },
    YP1: {
        hash: 'ypdldfe',
        name: 'Your Policy',
        agency: true,
        serviceAgreement: true,
        informationId: 'YP1'
    },
    ZB1: {
        hash: 'thewnvsapfew',
        name: 'The Zebra',
        agency: true
    },
    /** For testing purposes */
    SEAMLESS1: {
        hash: 'SEAMLESS1',
        name: 'SEAMLESS1'
    },
    ...largeAgencyCodes_1.default
};
exports.default = affinityGroups;
//# sourceMappingURL=affinityGroups.js.map